import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { PromptModal } from './components/PromptModal';
import type { PromptRequest } from './components/PromptModal';

type OpenPrompt = (request: PromptRequest) => void;

const PromptContext = createContext<OpenPrompt>(() => {});

/** Hosts the single percentage-input dialog the whole app shares. */
export function PromptProvider({ children }: { children: React.ReactNode }) {
  const [request, setRequest] = useState<PromptRequest | null>(null);
  const open = useCallback<OpenPrompt>((r) => setRequest(r), []);
  const value = useMemo(() => open, [open]);

  return (
    <PromptContext.Provider value={value}>
      {children}
      <PromptModal request={request} onClose={() => setRequest(null)} />
    </PromptContext.Provider>
  );
}

export function usePrompt(): OpenPrompt {
  return useContext(PromptContext);
}
